
import React from "react";

export const handleFileUpload = (
  e: React.ChangeEvent<HTMLInputElement>, 
  setFile: (file: File | null) => void, 
  setPreview: (url: string) => void, 
  setFormValue: (value: string) => void
) => {
  const file = e.target.files?.[0];
  if (file) {
    setFile(file);
    setFormValue(file.name);
    
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result as string);
    };
    reader.readAsDataURL(file);
  }
};
